import { Mode } from './@types/env';

export const DISABLE_BEFOREUNLOAD_WARNING =
  import.meta.env.VITE_DISABLE_BEFOREUNLOAD_WARNING === 'true';
export const SHOW_USER_ACTIVATION = import.meta.env.VITE_SHOW_USER_ACTIVATION === 'true';
export const ENABLE_MOCKING = import.meta.env.VITE_ENABLE_MOCKING === 'true';
export const OVERWRITE_USE_LIVE_TRANSLATIONS =
  import.meta.env.VITE_OVERWRITE_USE_LIVE_TRANSLATIONS === 'true';
export const MODE = import.meta.env.MODE as Mode;
